import { render, staticRenderFns } from "./TextFieldsWrapper.vue?vue&type=template&id=01e53b92&"
import script from "./TextFieldsWrapper.vue?vue&type=script&lang=ts&"
export * from "./TextFieldsWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports